export const LIST_LIMIT = 25;
export const SELECT_LIMIT = 50;
export const PAGE_SIZES = [25, 50, 100, 200];
